import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Input from '@material-ui/core/Input';
import CategoryIcon from '@material-ui/icons/Category';

import InputSelect from '~/components/Input/InputSelect';
import Paper from '~/components/Paper';
import InputControl from '~/components/Input/InputControl';
import Form from '~/containers/Form';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import useStyles from './styles';
import AppointmentCategoriesRecord from '~/records/AppointmentCategoriesRecord';
import Request from '~/providers/Request';

const attrName = (attr) =>
  AppointmentCategoriesRecord.hummanAttributeName(attr);

function AppointmentCategoriesItem({
  record,
  handleChange,
  onSubmit,
  loading,
  setRecord,
}) {
  const classesRoot = useStyles();
  const { t } = useTranslation();
  const [tagOptions, setTagOptions] = useState([]);

  const fetchSpecialties = () => {
    Request.get('/admin/appointment_tags', null, { normalizeJSON: true })
      .then((response) => {
        setTagOptions(response.data);
      })
      .catch((e) => {
        console.log(e);
        setTagOptions([]);
      });
  };

  useEffect(() => {
    fetchSpecialties();
  }, []);

  return (
    <>
      <Form onSubmit={onSubmit}>
        <Paper
          Icon={CategoryIcon}
          iconColor="purple"
          title={t('appointmentCategories.defSingular')}
          loading={loading}
        >
          <div className={clsx(classesRoot.root)}>
            <GridContainer>
              <GridItem xs={12} md={6}>
                <InputControl
                  name={'name'}
                  value={record.get('name')}
                  label={attrName('name')}
                  required={true}
                  inputComponent={Input}
                  onChange={handleChange}
                />
              </GridItem>

              <GridItem xs={12}>
                <InputControl
                  name={'tags'}
                  label={attrName('tags')}
                  value={record.get('tags')}
                  inputComponent={InputSelect}
                  onChange={({ tags }) => {
                    setRecord(record.updateAttributes({ tags: tags }));
                  }}
                  InputProps={{
                    isClearable: false,
                    isMulti: true,
                    options: tagOptions,
                  }}
                />
              </GridItem>
            </GridContainer>
          </div>
        </Paper>
      </Form>
    </>
  );
}

AppointmentCategoriesItem.propTypes = {
  record: PropTypes.instanceOf(AppointmentCategoriesRecord).isRequired,
  handleChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  setRecord: PropTypes.func.isRequired,
};

AppointmentCategoriesItem.defaultProps = {
  loading: false,
};

export default React.memo(withRouter(AppointmentCategoriesItem));
